import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { CREDIT_FLOW_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class CreditFlow {
  static getPrintForm = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/files/getPrintForm', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getAgreementFiles = async clientId => {
    try {
      const searchParams = new URLSearchParams()
      searchParams.append('clientId', clientId)
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/files/getAgreementFiles?${searchParams.toString()}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getTempFilesByField = async field => {
    try {
      const response = await HTTPHandler.get(CREDIT_FLOW_API_URL + '/temp-files/' + field, { responseType: 'blob' })

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }

  static getSingleFile = async (clientId, loanApplicationId) => {
    try {
      const searchParams = new URLSearchParams()
      searchParams.append('clientId', clientId)
      searchParams.append('loanApplicationId', loanApplicationId)
      const result = await HTTPHandler.get(
        CREDIT_FLOW_API_URL + `/files/getQuestionnaireFile?${searchParams.toString()}`
      )
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getGaranteeFile = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/files/guaranteeLetter/${id}`)

      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getApplicationsList = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/loanApplications/list', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getClientsList = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/clients/list', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCollateralsList = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/collaterals/list', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getContractList = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/contract/list', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getApplicationById = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/loanApplications/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getActiveByToken = async () => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/loanApplications/activeByToken`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getBanks = async () => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/dict/bankData`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getHeadUnderwriterList = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/loanApplications/underwriterStatistic/list`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getUnderwriterStatistics = async () => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/loanApplications/underwriterStatistic/header`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCredAdminStatistic = async () => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/loanApplications/credAdminStatistic/header`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCollateralById = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/collaterals/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getClientById = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/clients/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static searchClientByIIN = async iin => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/clients/iin/${iin}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createByOtp = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/otp/send', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createClientsByOtp = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/otp/send', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static deleteApplicationById = async id => {
    try {
      const result = await HTTPHandler.delete(CREDIT_FLOW_API_URL + `/loanApplications/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static checkOtp = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/loanApplications/checkOtp', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static checkClientsOtp = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/clients/checkOtp', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static changeClientById = async data => {
    try {
      const result = await HTTPHandler.put(CREDIT_FLOW_API_URL + `/clients`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static changeApplicationById = async (id, data) => {
    try {
      const result = await HTTPHandler.put(CREDIT_FLOW_API_URL + `/loanApplications/${id}`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createCollateral = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/collaterals`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static updateCollateral = async (id, data) => {
    try {
      const result = await HTTPHandler.patch(CREDIT_FLOW_API_URL + `/collaterals/${id}`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static completeCreation = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/loanApplications/status/completeCreation`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static loanApplicationResult = async data => {
    try {
      const result = await HTTPHandler.patch(CREDIT_FLOW_API_URL + `/loanApplications/status`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static loanApplicationPromote = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/loanApplications/promote`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static deleteCollateral = async id => {
    try {
      const result = await HTTPHandler.delete(CREDIT_FLOW_API_URL + `/collaterals/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createByExistingClient = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/loanApplications`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCreditProducts = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/dict/creditProducts`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static assignByRole = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/loanApplications/assignByRole`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static addComment = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/chat/addComment`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getChatHistory = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/chat/getByLoanApplicationId/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getDDS = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/dds/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getFileCategories = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/files/fileCategories/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static deleteFile = async id => {
    try {
      const result = await HTTPHandler.delete(CREDIT_FLOW_API_URL + `/files/delete/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getFile = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/files/${id}`, { responseType: 'blob' })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getBsData = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/dict/bsData`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getDealerCenters = async code => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/dict/dealerCenters?dealerGroupCode=${code}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getDealerCenterName = async code => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/dict/dealerCenters?dealerCenterName=${code}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCarBrands = async code => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/dict/carBrands`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getCarModels = async brand => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/dict/carModels/${brand}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static uploadFile = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/files/upload`, data, {
        'Content-Type': 'multipart/form-data'
      })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createDDS = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/dds`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createBSDDS = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/dds/createBSDDS`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static updateDDS = async data => {
    try {
      const result = await HTTPHandler.put(CREDIT_FLOW_API_URL + `/dds`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static createAlternatives = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/alternative/create`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static sendAlternative = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/alternative/choose`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getAlternatives = async id => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/alternative/byLoanApplicationId/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static generateDdsFile = async data => {
    try {
      const result = await HTTPHandler.post(
        CREDIT_FLOW_API_URL + `/dds/generateFile`,
        data,
        {},
        { responseType: 'arraybuffer' }
      )
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static updateRepaymentDate = async data => {
    try {
      const result = await HTTPHandler.patch(CREDIT_FLOW_API_URL + `/contract`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static getBsClientApplications = async iin => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + `/loanApplications/loan-apps/${iin}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
  static sendDocumentsToSign = async id => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/files/sendDocumentsToSign/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getDealerGroupsFilter = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/dict/dealer-groups/filter', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static createDealerGroup = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/dict/dealer-groups', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static updateDealerGroup = async (id, data) => {
    try {
      const result = await HTTPHandler.put(CREDIT_FLOW_API_URL + `/dict/dealer-groups/${id}`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static deleteDealerGroup = async id => {
    try {
      const result = await HTTPHandler.delete(CREDIT_FLOW_API_URL + `/dict/dealer-groups/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getDealerCentersFilter = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/dict/dealer-centers/filter', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static createDealerCenter = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/dict/dealer-centers', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static updateDealerCenter = async (id, data) => {
    try {
      const result = await HTTPHandler.put(CREDIT_FLOW_API_URL + `/dict/dealer-centers/${id}`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static deleteDealerCenter = async id => {
    try {
      const result = await HTTPHandler.delete(CREDIT_FLOW_API_URL + `/dict/dealer-centers/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getCitiesFilter = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/dict/cities/filter', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getCitiesDropdown = async () => {
    try {
      const result = await HTTPHandler.get(CREDIT_FLOW_API_URL + '/dict/cities/dropdown')
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static createCity = async data => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + '/dict/cities', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static updateCity = async (id, data) => {
    try {
      const result = await HTTPHandler.put(CREDIT_FLOW_API_URL + `/dict/cities/${id}`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static deleteCity = async id => {
    try {
      const result = await HTTPHandler.delete(CREDIT_FLOW_API_URL + `/dict/cities/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static resignDocument = async id => {
    try {
      const result = await HTTPHandler.post(CREDIT_FLOW_API_URL + `/loanApplications/resignDocuments/${id}`)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static updateCreditProduct = async data => {
    try {
      const result = await HTTPHandler.patch(CREDIT_FLOW_API_URL + `/loanApplications/loanProduct`, data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }
}
